jQuery(function () {

    $("[data-hide-on-category]").each((index, item) => {
        const categoryId = $(item).data('category-to-hide-from');
        if(!!categoryId) {
            window.pixelpoint.pubSub.subscribe(
                window.pixelpoint.pubSub.events.categoryChanged, (e, data) => {
                    let hideMe = false;
                    let ids = [];
                    $('.group-names-container input[type="hidden"]').each((index, item) => {
                        ids.push($(item).val());
                    });
                    ids = ids.concat(data).map(x => parseInt(x));
                    ids = [... new Set(ids)];
                    if(ids.length == 1 && ids[0] == categoryId) {
                        hideMe = true;
                    }
                    if(hideMe){
                        $(item).addClass("hide");
                    }
                    else{
                        $(item).removeClass("hide");
                    }
                }
            );
        }
    });
});